






import { convert2UTC, convert2UnifiedUTCFormat } from '@tt4b/ttam-utils';
import { defineComponent, computed } from '@vue/composition-api';
import { StateEnum, useStore, useStdAccountStore } from '@tt4b/ttam-hooks';
import { PropType } from 'vue';
import { TimeZone } from '../types';

const name = 'ttam-schedule-timezone';

export default defineComponent({
  name,
  props: {
    timezone: {
      type: String,
    },
    timezoneList: {
      type: Array as PropType<TimeZone[]>,
    },
    hideLabel: { type: Boolean, default: false },
    isNewFormat: { type: Boolean, default: false },
  },
  setup(props) {
    const { timezone } = useStdAccountStore();
    const { state } = useStore();
    const timezoneList = computed(() => state[StateEnum.timezoneList].data?.value?.timezone_list ?? []);

    const timezoneStr = computed(() =>
      props.isNewFormat
        ? convert2UnifiedUTCFormat(props.timezone || timezone.value, props.timezoneList || timezoneList.value)
        : convert2UTC(props.timezone || timezone.value, props.timezoneList || timezoneList.value),
    );

    return {
      name,
      timezoneStr,
    };
  },
});
